import { Box, Button } from "@mui/material"; // use MUI v5
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllDeepAnalysis } from "../../utils/api";

const Analysis = () => {
  const navigate = useNavigate();
  const [deepAnalysis, setDeepAnalysis] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // fetch data directly here
  const fetchData = async () => {
    try {
      const response = await getAllDeepAnalysis();
      if (response?.data?.data) {
        setDeepAnalysis(response.data.data); 
      }
    } catch (error) {
      console.error("Error fetching deep analysis:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // auto refresh every 5s
    const intervalId = setInterval(fetchData, 5000);
    return () => clearInterval(intervalId);
  }, []);

  const handleRedirect = (item) => {
    const scan_id = item.split(":")[1];
    const sub_scan_id = item.split(":")[2];
    navigate(`/deep-analysis/${scan_id}/${sub_scan_id}`);
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto" }}>
      <header
        style={{
          padding: 15,
          textAlign: "center",
          backgroundColor: "rgb(34, 93, 153)",
          color: "white",
          position: "sticky",
          top: 0,
        }}
      >
        Deep Analysis
      </header>

      <main
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Box mb={3}>
          <h4 style={{ textAlign: "center" }}>
            <u>Deep Analysis Request Arrival</u>
          </h4>
        </Box>

        {isLoading ? (
          <p>Loading scans...</p>
        ) : deepAnalysis.length === 0 ? (
          <p>No Deep Analysis records found</p>
        ) : (
          deepAnalysis.map((item, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={2}
              gap={1}
            >
              <span>{item}</span>
              <Button variant="contained" onClick={() => handleRedirect(item)}>
                Update
              </Button>
            </Box>
          ))
        )}
      </main>
    </div>
  );
};

export default Analysis;
